module.exports = "/img/_/_/_/assets/images/creeper/battle/rare//7.jpg?7e62d054fdeb20445124d81953d8caaf";